import styled, { css } from "styled-components";
import { FlexBox, FInter, MagicBox } from "@brg/ui";
import { LayoutConst } from "core/modules"

type IProps = {
    theme: any;
    column?: boolean;
    mr?: number;
    mt?: number;
    visible?: boolean;
    breakCheckbox?: boolean;
}

export const SearchBarWrapper = styled(FlexBox)<{orientFix?: boolean, isTagPage?: boolean }>`
    flex-flow: column;

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-bottom: ${({ isTagPage }) => isTagPage ? '0px' : '16px'};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        flex-flow: ${p => p?.orientFix ? 'column' : 'row'};
        justify-content: space-between;
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        justify-content: flex-start;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin-bottom: ${({ isTagPage }) => isTagPage ? '16px' : '16px'};
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column wrap;
    }
`;

export const SearchInputsWrapper = styled(FInter.SmallTextFlex)<IProps>`
    display: flex;
    flex-flow: row;
    font-size: 15px !important;
    color: ${({ theme }) => theme.projectEdit.label} !important;
    width: 100%;

    ${({ breakCheckbox }) => breakCheckbox && css`
    ${MagicBox} {
        margin-bottom: 24px;
    }
        // ${MagicBox}:last-child {
        //     margin-top: 24px;
        // }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            // ${MagicBox}:last-child {
            //     margin-top: 0px;
            // }
            ${MagicBox} {
                margin-bottom: 0px;
            }
        }
    `};

    .brg-input__control, .brg-input__menu {
        background-color: ${({ theme }) => theme.tagAdminPage.inputs.bg};
        border: none;
    }

    .brg-input__menu-list {
        ::-webkit-scrollbar {
            height: 2px;
        }
        ::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.tagAdminPage.scrollBar.bg};
        }
        ::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.tagAdminPage.scrollBar.trackBg};
        }
    }

    .brg-input__indicator {
        opacity: 1;
        svg path {
            fill: ${({ theme }) => theme.tagAdminPage.icons.fill};
        }
    }

    .brg-input__menu {
        * {
            color: ${({ theme }) => theme.tagAdminPage.select.color};
            font-weight: 600;
            font-size: 17px;
            line-height: 22px;
        }

        svg path {
            fill: ${({ theme }) => theme.tagAdminPage.select.color};
        }
    }
  
    & > {
        margin: ${p => `${p?.mt}px ${p?.mr}px 0 0`}
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        // .checkboxes {
        //     padding-top: 24px !important;
        //     padding-bottom: 16px;
        // }
    }
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        // place-items: normal;
        flex-flow: column;
        place-items: flex-start;

      .checkboxes:first-child {
        padding-top: 0px !important;
        height: 24px !important;
      }
      .checkboxes {
        padding-top: 10px !important;
        height: 36px !important;
      }
    }
`;

export const SearchDateBlock = styled(FlexBox)<{orientFix?: boolean}>`
@media(max-width: ${LayoutConst.screen.s - 1}px) {
    flex-flow: ${p => p?.orientFix ? 'column' : 'row'};
    justify-content: space-between;
    flex-wrap: wrap;

    label {
        margin-right: 3px !important;
    }

    input {
        width: 110px !important;
    }
}

@media(max-width: 420px) {
    flex-wrap: wrap;
    label {
        width: 100%;
        height: 100%;
        padding-bottom: 10px;
    }

    input {
        width: 130px !important;
    }

    div:first-child {
        width: 50%;
    }

    div:last-child {
        width: 50%;
    }
}


`;

export const SearchSelectBlock = styled(FlexBox)`
    margin-left: 24px;

    @media(max-width: ${LayoutConst.screen.md}px) {
        padding-top: 10px;
        margin-left: 0;
    }
`;

export const SelectLabel = styled.label<IProps>`
    margin: 0 15px 8px 0;
    display: ${p => p.visible ?  "none" : "inline-block"};

    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    
    @media(max-width: ${LayoutConst.screen.md}px) {
        margin-right: 0;
        margin-bottom: 0;
        min-width: 90px;
        width: 90px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        margin-left: 0;
    }
`;


export const ModerInfoWrapper = styled(FlexBox)<{isDarkTheme?: boolean}>`
    width: 100%;
    height: 46px;
    margin-left: 24px;
    align-items: center;
    gap: 24px;
    border-radius: 3px;

    * {
        color: ${({isDarkTheme}) => isDarkTheme ? '#838382' : '#151514'};
    }

    .text {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        white-space: nowrap;
    }

    .title {
        // margin-right: 24px;
        width: 222px;
    }

    .title-wrapper {
        width: 222px;
    }

    .value {
        font-size: 17px;
        line-height: 22px;
        font-weight: 600;
        white-space: nowrap;
    }

    .devider {
        // margin-right: 24px;
        width: 1px;
        height: 100%;
        background-color: #CDCDCD;
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        margin-left: 0;
        margin-top: 24px;
        height: 39px;
        gap: 20px;

        .title-wrapper, .title {
            width: 155px;
        }

        .text, .value {
            font-size: 11px;
            line-height: 13px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-flow: column; 
        align-items: start;
        gap: 12px;
        padding: 0px;
        height: 100%;

        .title-wrapper, .title {
            width: 100%;
        }

        .devider {
            width: 100%;
            height: 1px;
        }

        .text, .value {
            font-size: 13px;
            line-height: 16px;
        }
    }
`;

export const ModerateCountContainer = styled(FlexBox)<{ hideBackground?: boolean }>`
    background-color: ${({ theme, hideBackground }) => hideBackground ? 'transparent' : theme.tagAdminPage.inputs.bg};
    border-radius: 3px;
    padding: 8px;
    height: 100%;
    width: 100%;

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        height: 39px;
    }
`;

export const TagEditButton = styled(FlexBox)`
    min-width: 258px;
    max-width: 258px;
    height: 48px;
    display: flex;
    justify-content: center;
    place-items: center;
    white-space: nowrap;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    border-radius: 3px;
    cursor: pointer;
    padding: 13px 28px;
    border: 1px solid ${({ theme }) => theme.tags.tagEditModal.buttons.edit.borderColor};
    color: ${({ theme }) => theme.tags.tagEditModal.buttons.edit.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        min-width: 191px;
        padding: 13px 24px;
        height: 40px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: none;
        font-size: 15px;
        line-height: 20px;
        height: 46px;
    }
`

import styled, { css } from "styled-components";
import { FlexBox, FInter, MagicBox } from "@brg/ui";
import { LayoutConst } from "core/modules"

type IProps = {
    theme: any;
    column?: boolean;
    mr?: number;
    mt?: number;
    visible?: boolean;
    breakCheckbox?: boolean;
}

export const SearchBarWrapper = styled(FlexBox)<{orientFix?: boolean, isTagPage?: boolean }>`
    flex-flow: column;

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-bottom: ${({ isTagPage }) => isTagPage ? '0px' : '16px'};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        flex-flow: ${p => p?.orientFix ? 'column' : 'row'};
        justify-content: space-between;
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        justify-content: flex-start;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin-bottom: ${({ isTagPage }) => isTagPage ? '16px' : '16px'};
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column wrap;
    }
`;

export const SearchInputsWrapper = styled(FInter.SmallTextFlex)<IProps>`
    display: flex;
    flex-flow: row;
    font-size: 15px !important;
    color: ${({ theme }) => theme.projectEdit.label} !important;
    width: 100%;

    ${({ breakCheckbox }) => breakCheckbox && css`
    ${MagicBox} {
        margin-bottom: 24px;
    }
        // ${MagicBox}:last-child {
        //     margin-top: 24px;
        // }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            // ${MagicBox}:last-child {
            //     margin-top: 0px;
            // }
            ${MagicBox} {
                margin-bottom: 0px;
            }
        }
    `};

    .brg-input__control, .brg-input__menu {
        background-color: ${({ theme }) => theme.tagAdminPage.inputs.bg};
        border: none;
    }

    .brg-input__menu-list {
        ::-webkit-scrollbar {
            height: 2px;
        }
        ::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.tagAdminPage.scrollBar.bg};
        }
        ::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.tagAdminPage.scrollBar.trackBg};
        }
    }

    .brg-input__indicator {
        opacity: 1;
        svg path {
            fill: ${({ theme }) => theme.tagAdminPage.icons.fill};
        }
    }

    .brg-input__menu {
        * {
            color: ${({ theme }) => theme.tagAdminPage.select.color};
            font-weight: 600;
            font-size: 17px;
            line-height: 22px;
        }

        svg path {
            fill: ${({ theme }) => theme.tagAdminPage.select.color};
        }
    }
  
    & > {
        margin: ${p => `${p?.mt}px ${p?.mr}px 0 0`}
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        // .checkboxes {
        //     padding-top: 24px !important;
        //     padding-bottom: 16px;
        // }
    }
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        // place-items: normal;
        flex-flow: column;
        place-items: flex-start;

      .checkboxes:first-child {
        padding-top: 0px !important;
        height: 24px !important;
      }
      .checkboxes {
        padding-top: 10px !important;
        height: 36px !important;
      }
    }
`;

export const SearchDateBlock = styled(FlexBox)<{orientFix?: boolean}>`
@media(max-width: ${LayoutConst.screen.s - 1}px) {
    flex-flow: ${p => p?.orientFix ? 'column' : 'row'};
    justify-content: space-between;
    flex-wrap: wrap;

    label {
        margin-right: 3px !important;
    }

    input {
        width: 110px !important;
    }
}

@media(max-width: 420px) {
    flex-wrap: wrap;
    label {
        width: 100%;
        height: 100%;
        padding-bottom: 10px;
    }

    input {
        width: 130px !important;
    }

    div:first-child {
        width: 50%;
    }

    div:last-child {
        width: 50%;
    }
}


`;

export const SearchSelectBlock = styled(FlexBox)`
    margin-left: 24px;

    @media(max-width: ${LayoutConst.screen.md}px) {
        padding-top: 10px;
        margin-left: 0;
    }
`;

export const SelectLabel = styled.label<IProps>`
    margin: 0 15px 8px 0;
    display: ${p => p.visible ?  "none" : "inline-block"};

    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    
    @media(max-width: ${LayoutConst.screen.md}px) {
        margin-right: 0;
        margin-bottom: 0;
        min-width: 90px;
        width: 90px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        margin-left: 0;
    }
`;


export const ModerInfoWrapper = styled(FlexBox)<{isDarkTheme?: boolean}>`
    width: 100%;
    height: 46px;
    margin-left: 24px;
    align-items: center;
    gap: 24px;
    border-radius: 3px;

    * {
        color: ${({isDarkTheme}) => isDarkTheme ? '#838382' : '#151514'};
    }

    .text {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        white-space: nowrap;
    }

    .title {
        // margin-right: 24px;
        width: 222px;
    }

    .title-wrapper {
        width: 222px;
    }

    .value {
        font-size: 17px;
        line-height: 22px;
        font-weight: 600;
        white-space: nowrap;
    }

    .devider {
        // margin-right: 24px;
        width: 1px;
        height: 100%;
        background-color: #CDCDCD;
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        margin-left: 0;
        margin-top: 24px;
        height: 39px;
        gap: 20px;

        .title-wrapper, .title {
            width: 155px;
        }

        .text, .value {
            font-size: 11px;
            line-height: 13px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-flow: column; 
        align-items: start;
        gap: 12px;
        padding: 0px;
        height: 100%;

        .title-wrapper, .title {
            width: 100%;
        }

        .devider {
            width: 100%;
            height: 1px;
        }

        .text, .value {
            font-size: 13px;
            line-height: 16px;
        }
    }
`;

export const ModerateCountContainer = styled(FlexBox)<{ hideBackground?: boolean }>`
    background-color: ${({ theme, hideBackground }) => hideBackground ? 'transparent' : theme.tagAdminPage.inputs.bg};
    border-radius: 3px;
    padding: 8px;
    height: 100%;
    width: 100%;

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        height: 39px;
    }
`;

export const TagEditButton = styled(FlexBox)`
    min-width: 258px;
    max-width: 258px;
    height: 48px;
    display: flex;
    justify-content: center;
    place-items: center;
    white-space: nowrap;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    border-radius: 3px;
    cursor: pointer;
    padding: 13px 28px;
    border: 1px solid ${({ theme }) => theme.tags.tagEditModal.buttons.edit.borderColor};
    color: ${({ theme }) => theme.tags.tagEditModal.buttons.edit.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        min-width: 191px;
        padding: 13px 24px;
        height: 40px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: none;
        font-size: 15px;
        line-height: 20px;
        height: 46px;
    }
`

